<template>
  <div style="display:grid; min-height:100vh;">
    <!-- <loading
          :active.sync="isLoading"
          :can-cancel="false"
          loader="dots"
          :is-full-page="fullPage"
          :height="height"
          :width="width"
          background-color="#6b6969"
        ></loading>-->
    <green-nav />
    <div class="section section-basic mt-5">
      <div class="custom-container-fluid">
        <div class="row" style="margin-top: 2rem">
          <div class="col-md-12">
            <div class="text-center mb-5">
              <img src="../../public/assets/img/glit.jpg" class="img-fluid" alt="">

            </div>
            <h2 class="text-center" style="font-weight: bolder">Ghana Ladies In Tech Award Norminations</h2>
            <p class="text-center">Celebrating outstanding female efforts and achievements</p>
  
            <hr/>
            <h4 class="mt-5">
              This year we are Celebrating outstanding female efforts and
              achievements in the tech ecosystem across Ghana at the maiden
              edition of the GLiT Summit and Awards.
            </h4>
            <h4>
              The Ghana Ladies in Tech Awards will recognize and reward women
              entrepreneurs and innovators who are thriving and excelling in
              their careers and businesses
            </h4>
            <h4 style="font-weight: bolder" class="mt-4 mb-4">
              Date: 24th September 2021 <br />
              Venue: Accra Digital Centre
            </h4>
            <h4>
              Kindly do select the category you are interested in and enter your
              details for a certified nomination.
            </h4>
            <div class="text-center mt-5">
              <button
                class="btn btn-green"
                @click="$router.push('/glit-award-normination')"
              >
                Fill Normination here
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
// import Swal from "sweetalert2";
import GreenNav from "../components/navbar_green";
import downFooter from "../components/footer";
import axios from "axios";
export default {
  data() {
    return {
      isLoading: false,
      fullPage: true,
      height: 128,
      width: 128,
      events: []
    };
  },
  components: {
    // Loading,
    downFooter,
    GreenNav
  },

  methods: {
    formatDate(d) {
      return moment(d).format("MMM");
    },
    getDayFromDate(d) {
      return d ? moment(d).format("D") : "";
    },
    getFullDate(d) {
      return d ? moment(d).format("DD MMM YYYY") : "";
    },
    getEvents() {
      this.isLoading = true;
      axios
        .get(
          "https://ladies-in-tech-webservice.azurewebsites.net/all-activities"
        )
        .then(res => {
          const { data } = res;
          this.events = data.data;
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  },

  created() {
    this.$loadScript(
      "https://cdn.jsdelivr.net/npm/moment@2.27.0/min/moment.min.js"
    ).then(() => {
      this.getEvents();
    });
    document.body.style.background = "#ffffff";
  }
};
</script>

<style scoped>
.b-items__cars-one-img-type {
  border-radius: 5px;
  font: 700 10px "Open Sans", sans-serif;
  padding: 2px 5px;
  text-transform: uppercase;
  position: absolute;
  /* top: 15px; */
  z-index: 1000;
  background: white;
  top: 20px;
  left: 20px;
}
@media screen and (max-width: 768px) {
  .sm-none {
    display: none;
  }
}
@media screen and (min-width: 769px) {
  .md-none {
    display: none;
  }
}
</style>
